import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createdocs">
                1.&nbsp;<span className="material-symbols-outlined">assignment_add</span>&nbsp;{translate('createdocs')}
            </Typography>
            <p><strong>{translate('createdocs')}</strong> is an act to create new Google Documents.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$newDocs_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the <strong>Provider ID</strong> of the Google Docs connection used to identify the Google Docs account (see <Box component={Link} to="/control-center/documentation/connections/docs ">here</Box> for making connections).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('title')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the title Documents.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$newDocs_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gdocs-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('title')}</span>
                            <div>New Document</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                    {
                                        "title": "New Document",
                                        "body": {
                                            "content": [
                                            {
                                                "startIndex": 1,
                                                "endIndex": 7,
                                                "paragraph": {
                                                "elements": [
                                                    {
                                                    "startIndex": 1,
                                                    "endIndex": 7,
                                                    "textRun": {
                                                        "content": "",
                                                        "textStyle": {}
                                                    }
                                                    }
                                                ],
                                                }
                                            },
                                            ]
                                        },
                                        "documentStyle": {
                                        },
                                        "namedStyles": {
                                        },
                                        "revisionId": "ALm37BX3DsadsGMuNKSYIlwjyi6ZScCWIAPqnrnlbHQAgBtu3HgsPe8WW4k58qoeq5-YrVd4cYtfTaMozZrYKQ",
                                        "suggestionsViewMode": "SUGGESTIONS_INLINE",
                                        "documentId": "1nSSBzMkrr4QbnQKq3QR7GCdnWqkRT_l68FkcMwe8pM4",
                                        "providerID": "gdocs-1a2b3c4d5e6g7h",
                                        "paragraphCount": 5
                                    }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getdocs">
                2.&nbsp;<span className="material-symbols-outlined">assignment</span>&nbsp;{translate('getdocs')}
            </Typography>
            <p><strong>{translate('getdocs')}</strong>is an action that retrieves a Google Docs object.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$docs_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the <strong>Provider ID</strong> of the Google Docs connection used to identify the Google Docs account (see <Box component={Link} to="/control-center/documentation/connections/docs ">here</Box> for making connections).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('documentid')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the ID or URL of the file you want to retrieve.</td>
                                <td></td>
                            </tr>
                            
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$docs_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gdocs-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('documentid')}</span>
                            <div>1zTG_XHbCnC5a5BD5k5WWxdbcYpnEDv4_FfdAPaE33ro</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "title": "New Document",
                                            "body": {
                                                "content": [
                                                {
                                                    "startIndex": 0,
                                                    "endIndex": 0,
                                                    "paragraph": {
                                                    "elements": [
                                                        {
                                                        "startIndex": 0,
                                                        "endIndex": 0,
                                                        "textRun": {
                                                            "content": "",
                                                            "textStyle": {}
                                                        }
                                                        }
                                                    ],
                                                    }
                                                },
                                                ]
                                            },
                                            "documentStyle": {
                                            },
                                            "namedStyles": {
                                            },
                                            "revisionId": "ALm37BX3DsadsGMuNKSYIlwjyi6ZScCWIAPqnrnlbHQAgBtu3HgsPe8WW4k58qoeq5-YrVd4cYtfTaMozZrYKQ",
                                            "suggestionsViewMode": "SUGGESTIONS_INLINE",
                                            "documentId": "1nSSBzMkrr4QbnQKq3QR7GCdnWqkRT_l68FkcMwe8pM4",
                                            "providerID": "gdocs-1a2b3c4d5e6g7h",
                                            "paragraphCount": 0
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="docsinsertparagraph">
                3.&nbsp;<span className="material-symbols-outlined">note_alt</span>&nbsp;{translate('docsinsertparagraph')}
            </Typography>
            <p><strong>{translate('docsinsertparagraph')}</strong> is an action that inserts text into a specified paragraph in Google Docs.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$docsInsertParagraph_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the <strong>Provider ID</strong> of the Google Docs connection used to identify the Google Docs account (see <Box component={Link} to="/control-center/documentation/connections/docs ">here</Box> for making connections).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the text used to insert into Google Docs.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('index')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>These are the specified index locations in the body of Google Documents.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$docsInsertParagraph_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gdocs-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>Hello</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('index')}</span>
                            <div>0</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "title": "New Document",
                                            "body": {
                                                "content": [
                                                {
                                                    "startIndex": 0,
                                                    "endIndex": 5,
                                                    "paragraph": {
                                                    "elements": [
                                                        {
                                                        "startIndex": 1,
                                                        "endIndex": 7,
                                                        "textRun": {
                                                            "content": "Hello",
                                                            "textStyle": {}
                                                        }
                                                        }
                                                    ],
                                                    }
                                                }
                                                ]
                                            },
                                            "documentStyle": {
                                            },
                                            "namedStyles": {
                                            },
                                            "revisionId": "ALm37BX3DsadsGMuNKSYIlwjyi6ZScCWIAPqnrnlbHQAgBtu3HgsPe8WW4k58qoeq5-YrVd4cYtfTaMozZrYKQ",
                                            "suggestionsViewMode": "SUGGESTIONS_INLINE",
                                            "documentId": "1nSSBzMkrr4QbnQKq3QR7GCdnWqkRT_l68FkcMwe8pM4",
                                            "providerID": "gdocs-1a2b3c4d5e6g7h",
                                            "paragraphCount": 5
                                            }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);